import { filterHours } from "../../../utils/functions";

export function filterAdvisors(list, filters) {
    if (filters) {
        list = filterHours(list, filters.hours);

        if (filters.type) {
            list = list.filter(item => {
                return isType(filters.type, item);
            });
        }
    }

    return list;
}

var types = {
    "Mortgage Lender": "mortgageLender",
    "Consumer Lender": "consumerLoan",
    "Business Lender": "businessLender",
    "Agricultural Lender": "agriculturalLender",
    "Wealth Advisor": "investmentAdvisor",
    "Private Wealth Advisor": "trustAdvisor",
    "Institutional Strategist": "institutionalStrategist",
    "Insurance Account Executive":"insuranceAccountExecutive",
    "Private Banker": "privateBanker"
}

function isType(type, item) {
    var prop = types[type];
    return item[prop] == true;
}
